import React, { useState } from 'react';
import { Phone, MapPin, Clock, Instagram, Lock } from 'lucide-react';
import { LegalModal, LegalDoc } from './LegalModal';
export function Footer() {
  const [activeDoc, setActiveDoc] = useState<LegalDoc>(null);
  return <footer className="bg-plum-950 border-t border-lavender-400/10 pt-20 pb-10 relative" data-id="element-110">
      <div className="absolute inset-0 bg-gradient-to-t from-plum-950 via-plum-950/95 to-transparent pointer-events-none" data-id="element-111"></div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative" data-id="element-112">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-113">
          <div className="lg:col-span-1" data-id="element-114">
            <h2 className="font-serif text-3xl tracking-widest text-lavender-50 mb-6" data-id="element-115">
              AFRIEL
            </h2>
            <p className="text-lavender-100/55 font-light text-sm leading-relaxed" data-id="element-116">
              A private LA sanctuary for the body and senses. Elevating the art
              of sensual touch through discretion, luxury, and bespoke
              experiences.
            </p>
          </div>

          <div data-id="element-117">
            <h4 className="text-lavender-50 uppercase tracking-widest text-sm mb-6" data-id="element-118">
              Contact
            </h4>
            <ul className="space-y-4 text-lavender-100/65 font-light text-sm" data-id="element-119">
              <li className="flex items-start gap-3" data-id="element-120">
                <Phone size={16} className="text-rose-400 mt-1 flex-shrink-0" data-id="element-121" />
                <a href="tel:+13104903242" className="hover:text-rose-300 transition-colors" data-id="element-122">
                  +1 (310) 490-3242
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-123">
                <MapPin size={16} className="text-rose-400 mt-1 flex-shrink-0" data-id="element-124" />
                <span data-id="element-125">
                  Los Angeles, CA
                  <br data-id="element-126" />
                  <span className="text-xs text-lavender-200/40" data-id="element-127">
                    Exact location upon confirmation
                  </span>
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-128">
            <h4 className="text-lavender-50 uppercase tracking-widest text-sm mb-6" data-id="element-129">
              Hours
            </h4>
            <ul className="space-y-4 text-lavender-100/65 font-light text-sm" data-id="element-130">
              <li className="flex items-start gap-3" data-id="element-131">
                <Clock size={16} className="text-rose-400 mt-1 flex-shrink-0" data-id="element-132" />
                <div data-id="element-133">
                  <p data-id="element-134">Monday — Sunday</p>
                  <p data-id="element-135">10:00 AM — 11:00 PM PST</p>
                  <p className="text-xs text-lavender-200/40 mt-1" data-id="element-136">
                    By Appointment Only · 21+
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div data-id="element-137">
            <h4 className="text-lavender-50 uppercase tracking-widest text-sm mb-6" data-id="element-138">
              Connect
            </h4>
            <div className="space-y-4" data-id="element-139">
              <a href="https://www.instagram.com/afriels.spa/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-lavender-100/65 hover:text-rose-300 transition-colors text-sm font-light" data-id="element-140">
                <Instagram size={18} data-id="element-141" />
                <span data-id="element-142">@afriels.spa</span>
              </a>
              <div className="flex items-center gap-2 text-lavender-100/65 text-sm font-light" data-id="element-143">
                <Lock size={16} className="text-rose-400" data-id="element-144" />
                <span data-id="element-145">All sessions private & discreet</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-lavender-400/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-146">
          <p className="text-lavender-200/40 text-xs font-light" data-id="element-147">
            &copy; {new Date().getFullYear()} Afriel Sanctuary · Los Angeles.
            All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-lavender-200/40 font-light" data-id="element-148">
            <button onClick={() => setActiveDoc('privacy')} className="hover:text-lavender-100 transition-colors" data-id="element-149">
              Privacy Policy
            </button>
            <button onClick={() => setActiveDoc('terms')} className="hover:text-lavender-100 transition-colors" data-id="element-150">
              Terms of Service
            </button>
          </div>
        </div>
      </div>

      <LegalModal doc={activeDoc} onClose={() => setActiveDoc(null)} data-id="element-151" />
    </footer>;
}